import { Button, Stack, type Theme } from "@mui/material";
import type { Dispatch, FC, SetStateAction } from "react";
import {
	type ChartTimeFrameKey,
	ChartTimeFrames,
} from "web_myplann/Utils/types";

type Props = {
	timeFrame: ChartTimeFrameKey;
	setTimeFrame: Dispatch<SetStateAction<ChartTimeFrameKey>>;
};

export const DataLineChartButtons: FC<Props> = ({
	timeFrame,
	setTimeFrame,
}) => {
	const buttonSx = {
		width: 36,
		minWidth: 36,
		height: 24,
		borderRadius: 28,
		border: "none",
		fontSize: 12,
		fontWeight: 500,
		color: (theme: Theme) => theme.palette.myPLANN.main,
	};

	return (
		<Stack direction="row" justifyContent={"space-between"} paddingInline={2}>
			{Object.entries(ChartTimeFrames).map(([key, val]) => {
				const buttonTimeFrame = Number(key) as ChartTimeFrameKey;
				const isActive = timeFrame === buttonTimeFrame;

				return (
					<Button
						key={key}
						onClick={() => setTimeFrame(buttonTimeFrame)}
						variant={isActive ? "contained" : "outlined"}
						color="primary"
						sx={{
							...buttonSx,
							...(isActive && {
								backgroundColor: (theme: Theme) => theme.palette.myPLANN.main,
								color: (theme: Theme) => theme.palette.darkmodeText.white,
							}),
						}}
					>
						{val}
					</Button>
				);
			})}
		</Stack>
	);
};
